import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { IncrDataLoadScheduleService } from "src/app/shared/services/incr-data-load-schedule.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { IncrementalDataLoadSchedulePopupComponent } from "src/app/user/baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component";
import { debounceTime } from 'rxjs/operators';


@Component({
    selector: "app-create-meeting-pop-up",
    templateUrl: "./create-meeting-pop-up.component.html",
    styleUrls: ["./create-meeting-pop-up.component.scss"],
    standalone: false
})
export class CreateMeetingPopUpComponent implements OnInit {
  meetingForm!: FormGroup;

  meetingTypes = [
    { label: "One Time", value: "ONE_TIME" },
    { label: "Recurring", value: "RECURRING" },
  ];

  statuses = ["Planned", "Completed", "Cancelled"];

  usersList : any; // replace with API
  selectedSchedule: string = "";
  scheduleid: any | null = null;
  uniquenumber: number = 0;
  today = new Date();
  title = "Create Meeting";
  initialParticipants: number[] = [];
  isInitialLoad = true;
  meetingId!: number;
  tempScheduleId:number | null = null;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateMeetingPopUpComponent>,
    private secheduleService: IncrDataLoadScheduleService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
        private snackBar: MatSnackBar,
        private spinner: NgxUiLoaderService,
        private jsignalsService: JsignalService,
        private localStorageSettings: LocalStorageSettingsService,
         private commonService: CommonService,
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.loadUserList();

  if (this.data?.mode === 'EDIT') {
    this.title = 'Update Meeting';
    this.patchMeetingData(this.data.meetingData);
  } 
  else {
    this.title = 'Create Meeting';
    this.uniquenumber = this.generateUniqueId();
  }

  }

  initializeForm() {
    this.meetingForm = this.fb.group({
      meetingSubject: ["", [Validators.required,Validators.maxLength(250)]],
      participants: [[], Validators.required],
      isRecurring: [false],
      meetingStartDate: ["", Validators.required],
      meetingStartTime: ["", Validators.required],
      meetingEndTime: ["", Validators.required],
      scheduleDesc: ["", [Validators.maxLength(65535)]],
      agenda: ["",[Validators.maxLength(65535)]],
      // meetingType: ['', Validators.required]
      meetingLink: ["",[Validators.required,Validators.maxLength(65535)]]
    });

    // Set initial end time (default 1 hour duration)
    const now = new Date();
    // now.setHours(now.getHours() + 1);

    // START TIME (current time)
    const startTime =
      now.getHours().toString().padStart(2, "0") +
      ":" +
      now.getMinutes().toString().padStart(2, "0");

      const end = new Date();
      end.setHours(end.getHours() + 1);

    const endTimeString =
      end.getHours().toString().padStart(2, "0") +
      ":" +
      end.getMinutes().toString().padStart(2, "0");

    this.meetingForm.patchValue({
      meetingEndTime: endTimeString,
      meetingStartTime:startTime,
      meetingStartDate: now,
    });
  }

  patchMeetingData(meeting: any) {
  this.meetingForm.patchValue({
    meetingSubject: meeting.meetingSubject,
    participants: meeting.participants,
    meetingLink: meeting.meetingLink,
    isRecurring: meeting.isRecurring,
    meetingStartDate: meeting.meetingStartDate,
    meetingStartTime: meeting.meetingStartTime,
    meetingEndTime: meeting.meetingEndTime,
    agenda: meeting.agenda,
    scheduleDesc: meeting.scheduleDesc || ''
  });

  // Schedule values
  this.scheduleid = meeting.scheduleId;
  this.selectedSchedule = meeting.scheduleDesc;

  // Use existing unique number from backend
  this.uniquenumber = meeting.uniqueNumber;

   this.loadParticipantsForEdit(meeting.id);

  // Update validators based on recurring flag
  this.onRecurringChange();
}


onRecurringChange() {
  const isRecurring = this.meetingForm.get('isRecurring')?.value;

  const scheduleControl = this.meetingForm.get('scheduleDesc');

  if (isRecurring) {
    scheduleControl?.setValidators([Validators.required]);
  } else {
    scheduleControl?.clearValidators();
  }

  scheduleControl?.updateValueAndValidity();
}

  /**
   * Open schedule picker for recurring meetings
   */
  selectSchedulerClick() {
    let obj = {
      customreportmstrid: this.getUniqueNumber()
    };

    let dialogRef = this.dialog.open(
      IncrementalDataLoadSchedulePopupComponent,
      {
        panelClass: "custom-dialog-container-materialFulfilment",
        width: "80%",
        autoFocus: false,
        data: {
          edata: obj,
          scheduleFor: "jsip_meeting_schedule",
        },

        disableClose: true,
      },
    );

    dialogRef.afterClosed().subscribe((obj) => {
      if (obj) {
        this.scheduleid = obj.scheduleid;
        this.selectedSchedule = obj.scheduleDesc;
        this.meetingForm.patchValue({
          scheduleDesc: obj.scheduleDesc,
        });

        // If schedule has end time/duration, we could update form here
        // This would come from your schedule data
      }
    });
  }

 
  async deleteSchedule() {
    if (this.scheduleid != null) {
      await this.secheduleService.deleteDispatchHistory(this.scheduleid);
      this.scheduleid = null;
      this.selectedSchedule = "";
      this.meetingForm.patchValue({
        schedulePattern: "",
      });
    }
  }

  /**
   * Generate unique 4 digit number
   */
  generateUniqueId(): number {
    if(this.tempScheduleId){
      return this.tempScheduleId; // reuse if already generated in this session 
    }
    this.tempScheduleId = Math.floor(1000 + Math.random() * 9000);
    return this.tempScheduleId;
  }

  /**
   * Get unique number from localStorage or generate new
   */
  getUniqueNumber(): number {
  if (this.data?.mode === 'EDIT') {
    return this.data.meetingData.id; // already set from row data
  }
  return this.generateUniqueId();
}


 saveMeeting() {
  if (!this.meetingForm.valid) {
    Object.values(this.meetingForm.controls)
      .forEach(c => c.markAsTouched());
    return;
  }

    const dnsName = this.localStorageSettings.getSettings("dnsName");
    const workspaceId = this.localStorageSettings.getSettings("WorkspaceId");

    let url = this.meetingForm.get('meetingLink')?.value?.trim();

    const formattedUrl = this.formatUrl(url);

    if (!formattedUrl) {
      this.snackBar.open("Enter valid URL", "Ok", { duration: 3000 });
      return;
    }

      // convert date 
  const formattedMeetingDate = this.jsignalsService.toYYYYMMDD(
    this.meetingForm.get('meetingStartDate')?.value
  );
  console.log('Formatted Meeting Date:', formattedMeetingDate);

  const payload = {
    ...this.meetingForm.value,
    meetingStartDate: formattedMeetingDate,
    meetingLink: formattedUrl, 
    scheduleId: this.scheduleid,
    uniqueNumber: this.uniquenumber,
    dnsid: dnsName,
    workspaceid: workspaceId
  };

  if (this.data?.mode === 'EDIT') {
    // payload['meetingId'] = this.data.meetingData.id;
    console.log('Update payload', payload);
    // call UPDATE API
    this.updateMeeting(this.data.meetingData.id, payload);
  } else {
    console.log('Create payload', payload);
    // call CREATE API
    this.createMeeting(payload);
  }
  this.tempScheduleId = null; // reset temp schedule id after use
  console.log('Temp Schedule ID reset to null :  ', this.tempScheduleId);
}


  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.meetingForm.patchValue({ attachment: file });
  }

  close() {
    if (this.scheduleid && this.data?.mode !== 'EDIT') {
    const confirmed = window.confirm(
      "If you go back now, the schedule you created will be permanently deleted. Do you want to continue?"
    );
    if (!confirmed) {
      return;
    }
     this.clearSchedule();
  }
   
    this.dialogRef.close();
  }

  loadUserList() {
    const WorkspaceId = this.localStorageSettings.getSettings("WorkspaceId");
        console.log(WorkspaceId);
     this.spinner.start();  
     this.commonService.retrieveDnsUser(WorkspaceId).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackBar.open(response.statusMessage, 'OK', {duration: 5000});


      } else {

        this.spinner.stop();

        this.usersList = response;

      }
    });
  }

  createMeeting(payload:any){
    this.spinner.start();
    this.jsignalsService
      .createMeeting(payload)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
           this.dialogRef.close(payload);
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
        },
      }); 
  }

  updateMeeting(id:number , payload:any){
    console.log('Updating meeting with id:', id);
     this.spinner.start();
    this.jsignalsService
      .updateMeeting(id,payload)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
           this.dialogRef.close(payload);
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
        },
      }); 
  }

  loadParticipantsForEdit(meetingId: number) {
  this.jsignalsService.getMeetingParticipants(meetingId).subscribe({
    next: (res: any[]) => {

      // Convert response → ["199", "200"]
      const participantIds = res.map(user => Number(user.userId));

      // store baseline
      this.initialParticipants = [...participantIds];


      //  Patch into form
      this.meetingForm.patchValue({
        participants: participantIds
      });

       //start listening AFTER patch
      setTimeout(() => {
        this.isInitialLoad = false;
        this.listenToParticipantChanges();
      });

      console.log("Patched participants : ", participantIds);
    },
    error: (err) => {
      console.error("Error loading participants", err);
    }
  });
}

formatUrl(url: string): string | null {
  try {
    if (url && !/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }

    const parsed = new URL(url);

    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return url; // return fixed URL
    }

    return null;
  } catch (err) {
    console.error(`Invalid URL: ${url}`, err);
    return null;
  }
}

listenToParticipantChanges() {

  this.meetingForm.get('participants')?.valueChanges
    .pipe(debounceTime(500)) // wait for user to finish selecting
    .subscribe((current: number[]) => {

      if (this.isInitialLoad) return;

      const added = current.filter(x => !this.initialParticipants.includes(x));
      const removed = this.initialParticipants.filter(x => !current.includes(x));

      // CALL APIs
      if (added.length > 0) {
        this.addParticipants(added);
      }

      if (removed.length > 0) {
        this.removeParticipants(removed);
      }

      //update baseline
      this.initialParticipants = [...current];
    });
}

addParticipants(userIds: number[]) {
   console.log('Adding participants with ids:', userIds);
   console.log('To meeting id:', this.data.meetingData.id);

     this.spinner.start();
    this.jsignalsService
      .addParticipants(this.data.meetingData.id, userIds)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
        },
      }); 
} 

removeParticipants(userIds: number[]) {
  console.log('Removing participants with ids:', userIds);
   console.log('From meeting id:', this.data.meetingData.id);

     this.spinner.start();
    this.jsignalsService
      .removeParticipants(this.data.meetingData.id, userIds)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
        },
      }); 
}

errorStateMatcher = {
  isErrorState: (control: any) => {
    return !!(
      control &&
      control.invalid &&
      (control.touched || control.dirty)
    );
  }
};

clearSchedule(){
  this.tempScheduleId = null;
  this.deleteSchedule();
}

}
